import React from "react";
import CaseSetupStep from "./CaseSetupStep";
import CompanySelectionStep from "./CompanySelectionStep";
import CompanyDetailsStep from "./CompanyDetailsStep";
import ReviewStep from "./ReviewStep";
import ResultsStep from "./ResultsStep";

const GroupReliefOptimiserCanvas = ({ workspace, attempted }) => {
  if (workspace.step === 0)
    return (
      <CaseSetupStep
        settings={workspace.settings}
        updateSettings={workspace.updateSettings}
        attempted={attempted}
      />
    );
  if (workspace.step === 1)
    return <CompanySelectionStep workspace={workspace} />;
  return (
    <>
      {workspace.step === 3 && workspace.showResults && workspace.result ? (
        <ResultsStep workspace={workspace} />
      ) : (
        <CompanyDetailsStep workspace={workspace} attempted={attempted} />
      )}
      {workspace.reviewOpen && <ReviewStep workspace={workspace} />}
    </>
  );
};

export default GroupReliefOptimiserCanvas;
